import imgPhotoPrints from '~/assets/images/projects/project-quick-create-photo-prints.png';
import imgAutoBook from '~/assets/images/projects/project-quick-create-autobook-landscape.png';
import imgAutoMug from '~/assets/images/projects/project-quick-create-automug.png';
import imgAutoTabletop from '~/assets/images/projects/project-quick-create-autotabletop.png';
import imgAutoCoaster from '~/assets/images/projects/project-quick-create-autocoaster.png';
import imgAutoWaterBottle from '~/assets/images/projects/project-quick-create-autowaterbottle.png';
import imgSeamlessAutoBook from '~/assets/images/projects/project-quick-create-seamless-autobook.png';
import imgNotebook from '~/assets/images/projects/project-quick-create-notebook.png';
import imgAutoMagnet from '~/assets/images/projects/project-quick-create-automagnet.png';

export const PROJECT_STATUSES = {
  inProgress: 'in_progress',
  inCart: 'in_cart',
  ordered: 'ordered',
  printable: 'printable'
};

export const AUTO_PRINT_FILE_SELECTION_MODES = Object.freeze({
  none: 'none',
  file: 'file',
  container: 'container'
});

export const photoPrintConf = {
  id: 'photoPrint',
  isAutoPrint: true,
  name: 'Print Photos',

  imageUrl: imgPhotoPrints,
  description: 'Add to your order!',
};

export const autoPrintConfs = {
  photo_books: [
    {
      sku: 'FPPB-0001',
      imageUrl: imgAutoBook,
      name: 'FOREVER AutoBook',
      type: 'Standard Photo Book',
      isContainerPrint: true,
      fileSelectionMode: AUTO_PRINT_FILE_SELECTION_MODES.none
    }
  ],

  seamless_layflats: [
    {
      sku: 'AUTOSEAMLESS-001',
      imageUrl: imgSeamlessAutoBook,
      name: 'Seamless AutoBook',
      type: 'Deluxe Seamless Layflat',
      isContainerPrint: true,
      fileSelectionMode: AUTO_PRINT_FILE_SELECTION_MODES.none
    }
  ],
  mugs: [
    {
      sku: 'AUTOMUG-001',
      imageUrl: imgAutoMug,
      name: 'Mugs',
      fileSelectionMode: AUTO_PRINT_FILE_SELECTION_MODES.file
    }
  ],
  tabletop_panels: [
    {
      sku: 'AUTOTABLETOP-001',
      imageUrl: imgAutoTabletop,
      name: 'Tabletop Panels',
      fileSelectionMode: AUTO_PRINT_FILE_SELECTION_MODES.file
    }
  ],
  notebook_v2s: [
    {
      sku: 'NOTEBOOKV2-K0003-00032',
      imageUrl: imgNotebook,
      name: 'Notebooks',
      fileSelectionMode: AUTO_PRINT_FILE_SELECTION_MODES.file
    }
  ],
  coaster_sets: [
    {
      sku: 'AUTOCOASTERS-001',
      imageUrl: imgAutoCoaster,
      name: 'Coaster Sets',
      fileSelectionMode: AUTO_PRINT_FILE_SELECTION_MODES.container
    }
  ],
  magnets: [
    {
      sku: 'AUTOMAGNET-001',
      imageUrl: imgAutoMagnet,
      name: 'Magnets',
      fileSelectionMode: AUTO_PRINT_FILE_SELECTION_MODES.file
    }
  ],
  stainless_steel_water_bottles: [
    {
      sku: 'AUTOSSWATER-001',
      imageUrl: imgAutoWaterBottle,
      name: 'Water Bottles',
      fileSelectionMode: AUTO_PRINT_FILE_SELECTION_MODES.file
    }
  ]
};
